<template>
  <ProSpaceGeoLayout class="user">
    <template #top>
      <ProSpaceTopPanel :header="layoutName" back @back="backHandler" />
    </template>
    <template #center>
      <ProSpaceRadioButtonSecondary
        v-if="model"
        :tabs="tabs"
        v-model="modelTab"
        @select="handlerSelectRadio"
      >
        <ProSpaceAction
          :disabled="disabledSave || loading || rolesLoading"
          icon="double-check"
          :text="$t('saveAll')"
          @click="saveAll"
        />
        <template #profile>
          <ProSpaceGeoLayout
            is-template
            :template-center="true"
            :template-right="true"
          >
            <template #center>
              <ProSpaceTabs
                :tabs="profileTabs"
                :refLoading="false"
                v-model="modelTabPanel"
                :loading="loading"
                without-margin-bottom
              >
                <ProSpaceAction
                  :disabled="disabledSave"
                  icon="check"
                  :text="$t('save')"
                  @click="savePart(saveFields.Overview)"
                />
                <template v-slot:tab-1>
                  <ProSpaceVLayout :gap="10">
                    <ProSpaceGeoLayout class="geo-row">
                      <template v-slot:left>
                        <ProSpaceTextBlock
                          :top="$t('agencyLinkInfo')"
                          :bottom="$t('agencyLinkInfoSub')"
                          :gap="10"
                          type="third"
                          break-word
                        />
                      </template>
                      <template v-slot:center>
                        <ProSpaceVLayout :gap="20">
                          <ProSpaceDropdown
                            ref="userTypeDropdown"
                            getMethod="getTypes"
                            v-model="model.agencyLinkType"
                            propValue="value"
                            propLabel="text"
                            :label="$t('userType')"
                            :service="userService"
                            :invalid="v$.model.agencyLinkType.$error"
                            :invalid-messages="v$.model.agencyLinkType.$errors"
                            @change="userTypeChanged"
                            @blur="v$.model.agencyLinkType.$touch"
                          />
                          <ProSpaceDropdown
                            v-if="model.agencyLinkType === 'AGENCY'"
                            v-model="model.agencyLinkAgencyId"
                            ref="agencySearch"
                            getMethod="grid"
                            propValue="id"
                            propLabel="value"
                            argMethod="$filter=disabled eq false&$orderby=id"
                            :label="$t('userAgency')"
                            :placeholder="$t('selectTxt')"
                            :service="agencyService"
                            @change="
                              (item) =>
                                (model.agencyLinkAgencyValue = item?.value)
                            "
                            :invalid="v$.model.agencyLinkAgencyId.$error"
                            :invalid-messages="v$.model.agencyLinkAgencyId.$errors"
                            @blur="v$.model.agencyLinkAgencyId.$touch"
                          />
                        </ProSpaceVLayout>
                      </template>
                      <template
                        v-if="
                          v$.model.agencyLinkType.$error ||
                          v$.model.agencyLinkAgencyId.$error
                        "
                        v-slot:right
                      >
                        <ProSpaceWarning />
                      </template>
                    </ProSpaceGeoLayout>
                    <ProSpaceGeoLayout class="geo-row">
                      <template v-slot:left>
                        <ProSpaceTextBlock
                          :top="$t('mainInformation')"
                          :bottom="$t('userInformation')"
                          :gap="10"
                          type="third"
                          break-word
                        />
                      </template>
                      <template v-slot:center>
                        <ProSpaceVLayout :gap="20">
                          <ProSpaceHLayout align-items="flex-start" :gap="10">
                            <ProSpaceInputText
                              v-model="model.lastName"
                              :label="$t('lastName')"
                              :placeholder="$t('lastName')"
                              :invalid="v$.model.lastName.$error"
                              :invalid-messages="v$.model.lastName.$errors"
                              @blur="v$.model.lastName.$touch"
                            ></ProSpaceInputText>
                            <ProSpaceInputText
                              v-model="model.firstName"
                              :label="$t('firstName')"
                              :placeholder="$t('firstName')"
                              :invalid="v$.model.firstName.$error"
                              :invalid-messages="v$.model.firstName.$errors"
                              @blur="v$.model.firstName.$touch"
                            ></ProSpaceInputText>
                            <ProSpaceInputText
                              v-model="model.secondName"
                              :label="$t('secondName')"
                              :placeholder="$t('secondName')"
                              :invalid="v$.model.secondName.$error"
                              :invalid-messages="v$.model.secondName.$errors"
                              @blur="v$.model.secondName.$touch"
                            ></ProSpaceInputText>
                          </ProSpaceHLayout>
                          <ProSpaceHLayout align-items="flex-start" :gap="10">
                            <ProSpaceInputText
                              v-model="model.email"
                              :label="$t('holderEmail')"
                              :placeholder="$t('holderEmail')"
                              :invalid="v$.model.email.$error"
                              :invalid-messages="v$.model.email.$errors"
                              @blur="v$.model.email.$touch"
                            ></ProSpaceInputText>
                            <ProSpaceInputText
                              v-model="model.login"
                              :label="$t('login')"
                              :placeholder="$t('login')"
                              :invalid="v$.model.login.$error"
                              :invalid-messages="v$.model.login.$errors"
                              @blur="v$.model.login.$touch"
                            ></ProSpaceInputText>
                          </ProSpaceHLayout>
                        </ProSpaceVLayout>
                      </template>
                      <template
                        v-if="
                          v$.model.lastName.$error ||
                          v$.model.firstName.$error ||
                          v$.model.secondName.$error ||
                          v$.model.email.$error ||
                          v$.model.login.$error
                        "
                        v-slot:right
                      >
                        <ProSpaceWarning />
                      </template>
                    </ProSpaceGeoLayout>
                    <ProSpaceGeoLayout class="geo-row">
                      <template v-slot:left>
                        <ProSpaceTextBlock
                          type="third"
                          break-word
                          :top="$t('additionalInformation')"
                          :bottom="$t('additionalInformationInformation')"
                          :gap="10"
                          />
                      </template>
                      <template v-slot:center>
                        <ProSpaceVLayout :gap="20">
                          <ProSpaceInputText
                            v-model="model.comments"
                            :isTextarea="true"
                            :autoResize="false"
                            :label="$t('comments')"
                            :placeholder="$t('comments')"
                          />
                        </ProSpaceVLayout>
                      </template>
                    </ProSpaceGeoLayout>
                    <ProSpaceGeoLayout class="geo-row">
                      <template v-slot:left>
                        <ProSpaceTextBlock
                          type="third"
                          break-word
                          :top="$t('date')"
                          :bottom="$t('dateInformation')"
                          :gap="10"
                        />
                      </template>
                      <template v-slot:center>
                        <ProSpaceHLayout :gap="10">
                          <ProSpaceDropdown
                            v-model="model.dateFormat"
                            getMethod="getDateFormats"
                            :label="$t('dateFormat')"
                            :placeholder="$t('dateFormat')"
                            :service="dateHelperService"
                          />
                          <ProSpaceDropdown
                            v-model="model.timeZoneId"
                            getMethod="getTimeZone"
                            :label="$t('timeZone')"
                            :placeholder="$t('timeZone')"
                            :service="dateHelperService"
                          />
                          <ProSpaceDropdown
                            v-model="model.timeFormat"
                            getMethod="getTimeFormats"
                            :label="$t('timeFormat')"
                            :placeholder="$t('timeFormat')"
                            :service="dateHelperService"
                          />
                        </ProSpaceHLayout>
                      </template>
                    </ProSpaceGeoLayout>
                    <ProSpaceGeoLayout class="geo-row">
                      <template v-slot:left>
                        <ProSpaceTextBlock
                          type="third"
                          break-word
                          :top="$t('lastLoginDate')"
                          :bottom="$t('lastLoginDateInformation')"
                          :gap="10"
                        />
                      </template>
                      <template v-slot:center>
                        <ProSpaceVLayout :gap="20">
                          <ProSpaceInputText
                            :label="$t('lastLoginDateF')"
                            :modelValue="getFormatDateTime(model.lastLoginDate)"
                            :placeholder="$t('lastLoginDateF')"
                            :disabled="true"
                          />
                        </ProSpaceVLayout>
                      </template>
                    </ProSpaceGeoLayout>
                  </ProSpaceVLayout>
                </template>
              </ProSpaceTabs>
            </template>
          </ProSpaceGeoLayout>
        </template>
        <template #permissions>
          <ProSpaceGeoLayout
            is-template
            :template-center="true"
            :template-right="isUseCaseSelected || isUserRoleSelected"
          >
            <template #center>
              <ProSpaceTabs
                v-model="modelTabPanel"
                :tabs="tabsPanel"
                :loading="loading"
              >
                <ProSpaceHLayout :is-inline-w="true" :gap="10">
                  <ProSpaceAddInputButton
                    v-if="modelTabPanel.value === 'roles'"
                    ref="add-btn-roles"
                    searchValue="systemName"
                    getMethod="grid"
                    colName="systemName"
                    colDesc="displayName"
                    filterField="securityRoleId"
                    second-get-method="grid"
                    second-create-method="createWithMap"
                    second-delete-method="delete"
                    :id="masterId"
                    :service="roleService"
                    :second-service="userRoleService"
                    :addTxt="$t('add')"
                    :secondData="userRoleGridData"
                    :defaultFilter="{ disabled: { and: [false] } }"
                    :cancelTxt="$t('cancelTxt')"
                    :applyTxt="$t('applyTxt')"
                    :disabled="rolesLoading"
                    @apply="applyRoles"
                  />
                  <ProSpaceAction
                    v-if="modelTabPanel.value === 'restrictions'"
                    icon="plus"
                    :text="$t('add')"
                    @click="showMethadataModal"
                  />
                  <ProSpaceAction
                    v-if="modelTabPanel.value !== 'menuItems'"
                    icon="check"
                    :text="$t('save')"
                    :disabled="loading || rolesLoading"
                    @click="savePart(saveFields.Claims)"
                  />
                </ProSpaceHLayout>
                <template v-slot:tab-1>
                  <ProSpaceMainGrid
                    class="user__roles-grid"
                    ref="userRoleGrid"
                    getMethod="grid"
                    selectionMode="single"
                    :isHeadHide="true"
                    :removeBg="true"
                    :service="userRoleService"
                    :id="masterId"
                    :key="masterId"
                    :defaultFilter="{
                      securityUserId: { and: [model.id] },
                      disabled: { and: [false] },
                    }"
                    @loaded="userRoleGridLoaded()"
                    @selected-change="userRoleSelect"
                  >
                    <template #columns>
                      <Column>
                        <template #body="{ data }">
                          <ProSpaceTextBlock
                            layout="center"
                            type="primary"
                            :top="data.securityRoleSystemName"
                            :bottom="`${getFormatDate(
                              data.startDate
                            )} - ${getFormatDate(data.endDate)}`"
                          />
                        </template>
                      </Column>
                      <Column :header="$t('default')">
                        <template #body="{ data }">
                          <ProSpaceInputSwitch
                            v-if="data"
                            v-model="data.isCurrent"
                            justifyContent="center"
                            @update:modelValue="switchCurrentRoleHandler(data, $event)"
                            :noBorder="true"
                          />
                        </template>
                      </Column>
                      <Column>
                        <template #body="field">
                          <ProSpaceHLayout justify-content="flex-end">
                            <ProSpaceIconButton
                              icon="circle-close"
                              @click="removeUserRole(field.data)"
                            />
                          </ProSpaceHLayout>
                        </template>
                      </Column>
                    </template>
                    <template #empty>
                      <ProSpaceEmptyGrid
                        icon="empty-grid"
                        :title="$t('noDataTitle')"
                        :text="$t('noDataTxt')"
                      />
                    </template>
                  </ProSpaceMainGrid>
                </template>
                <template v-slot:tab-2>
                  <UserUseCases
                    ref="userUseCase"
                    :userId="model.id"
                    @selected-change="useCaseSelect"
                  />
                </template>
                <template v-slot:tab-3>
                  <ProSpaceGeoLayout>
                    <template #center>
                      <ProSpaceMainGrid
                        dataKey="menuItemId"
                        type="expand"
                        childFilterField="menuItemParentId"
                        getMethod="grid"
                        :key="masterId"
                        :service="menuItemUserService"
                        :isHeadHide="false"
                        :defaultFilter="{
                          securityUserId: { and: [Number(masterId)] },
                        }"
                        :defaultTreeFilter="{
                          securityUserId: { and: [Number(masterId)] },
                        }"
                      >
                        <template #columns>
                          <Column
                            field="menuItemTitle"
                            sortable
                            :header="$t('title')"
                          >
                            <template #body="field">
                              <ProSpaceDefaultTextColumn>
                                {{ field.data.menuItemTitle }}
                              </ProSpaceDefaultTextColumn>
                            </template>
                          </Column>
                          <Column
                            field="securityUserLogin"
                            sortable
                            :header="$t('user')"
                          >
                            <template #body="field">
                              <ProSpaceDefaultTextColumn>
                                {{ field.data.securityUserLogin }}
                              </ProSpaceDefaultTextColumn>
                            </template>
                          </Column>
                        </template>
                        <template #expansion>
                          <Column field="menuItemTitle" :header="$t('title')">
                            <template #body="field">
                              {{ field.data.menuItemTitle }}
                            </template>
                          </Column>
                        </template>
                        <template #empty>
                          <ProSpaceEmptyGrid
                            icon="empty-grid"
                            :title="$t('noDataTitle')"
                            :text="$t('noDataTxt')"
                          />
                        </template>
                      </ProSpaceMainGrid>
                    </template>
                  </ProSpaceGeoLayout>
                </template>
              </ProSpaceTabs>
            </template>
            <template #right>
              <ProSpaceRightPanel v-if="isUserRoleSelected" no-border>
                <template #center>
                  <ProSpacePanelBlock
                    :header="{ title: $t('role'), isExpand: false }"
                  >
                    <ProSpacePanelBlockList :list="contentUserRoles" />
                  </ProSpacePanelBlock>
                </template>
                <template #bottom>
                  <ProSpacePanelBlock :header="headerBottomUserRoles">
                    <template v-slot>
                      <ProSpacePanelBlockList :list="contentBottomUserRoles" />
                    </template>
                  </ProSpacePanelBlock>
                </template>
              </ProSpaceRightPanel>
              <ProSpaceRightPanel v-if="isUseCaseSelected" no-border>
                <template #center>
                  <ProSpacePanelBlock :header="{ title: $t('claim') }">
                    <template v-slot>
                      <ProSpaceSimpleGrid
                        prop-id="securityusecaseId"
                        getMethod="grid"
                        :headers="listHeadersUseCases"
                        :service="useCaseClaimService"
                        :id="selectedUseCaseId"
                        :key="selectedUseCaseId"
                        :btnText="$t('viewMore')"
                      />
                    </template>
                  </ProSpacePanelBlock>
                </template>
                <template v-slot:bottom>
                  <ProSpacePanelBlock :header="userPanelMeta">
                    <template v-slot>
                      <ProSpacePanelBlockList :list="userPanelMetaContent" />
                    </template>
                  </ProSpacePanelBlock>
                </template>
              </ProSpaceRightPanel>
            </template>
          </ProSpaceGeoLayout>
        </template>
      </ProSpaceRadioButtonSecondary>
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import {
  ProSpaceGeoLayout,
  ProSpaceTopPanel,
  ProSpaceInputText,
  ProSpaceDropdown,
  ProSpaceRadioButtonSecondary,
  ProSpaceSimpleGrid,
  ProSpaceMainGrid,
  ProSpaceRightPanel,
  ProSpaceTableHeaderCell,
  ProSpaceMultiSelect,
  ProSpaceCustomFilterPanel,
  ProSpaceAction,
  ProSpaceHLayout,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpaceTextBlock,
  ProSpaceIconButton,
  ProSpacePanelBlockList,
  ProSpacePanelBlockItem,
  ProSpaceVLayout,
  ProSpaceEmptyGrid,
  ProSpaceAddInputButton,
  ProSpaceDefaultTextColumn,
  ProSpaceSearchfield,
  ProSpaceInputSwitch,
  ProSpaceWarning,
  Validations,
} from "@prospace/prospace-components-library";
import { mapGetters } from "vuex";
import { UserService } from "../../services/UserService.js";
import { UserInfoService } from "../../services/UserInfoService.js";
import { UserRoleService } from "../../services/UserRoleService.js";
import { RoleService } from "../../services/RoleService.js";
import { MenuItemUserService } from "../../services/MenuItemUserService.js";
import { DateHelperService } from "../../services/DateHelperService.js";
import { UseCaseClaimService } from "../../services/UseCaseClaimService.js";
import { RestrictionService } from "../../services/RestrictionService.js";
import { MethadataService } from "../../services/MethadataService.js";
import { LoginTypeService } from "../../services/LoginTypeService.js";
import { AgencyService } from "../../../../../Services/AddressProgram/AddressProgram.Frontend/services/AgencyService.js";
import UserUseCases from "./components/UserUseCases.vue";
// import ProSpaceAddInputButtonTest from "./components/ProSpaceAddInputButtonTest.vue";
import Column from "primevue/column";
import {
  required,
  maxLength,
  helpers,
  createI18nMessage,
} from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import _ from "lodash";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  components: {
    ProSpaceGeoLayout,
    ProSpaceTopPanel,
    ProSpaceInputText,
    ProSpaceDropdown,
    ProSpaceRadioButtonSecondary,
    UserUseCases,
    ProSpaceSimpleGrid,
    ProSpaceMainGrid,
    Column,
    ProSpacePanelBlock,
    ProSpaceRightPanel,
    ProSpaceTableHeaderCell,
    ProSpaceMultiSelect,
    ProSpaceCustomFilterPanel,
    ProSpaceAction,
    ProSpaceHLayout,
    ProSpaceTabs,
    ProSpacePanelBlockList,
    ProSpacePanelBlockItem,
    ProSpaceVLayout,
    ProSpaceTextBlock,
    ProSpaceIconButton,
    ProSpaceEmptyGrid,
    ProSpaceAddInputButton,
    ProSpaceDefaultTextColumn,
    ProSpaceSearchfield,
    ProSpaceWarning,
    ProSpaceInputSwitch
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      // Tabs
      modelTab: null,
      modelTabPanel: null,
      loading: false,
      rolesLoading: false,

      // Common
      layoutName: "",
      model: null,
      startModel: null,
      useCaseSelected: false,
      selectedUseCaseId: null,

      // Service
      userService: new UserService(),
      userInfoService: new UserInfoService(),
      roleService: new RoleService(),
      userRoleService: new UserRoleService(),
      menuItemUserService: new MenuItemUserService(),
      dateHelperService: new DateHelperService(),
      useCaseClaimService: new UseCaseClaimService(),
      restrictionService: new RestrictionService(),
      methadataService: new MethadataService(),
      loginTypeService: new LoginTypeService(),
      agencyService: new AgencyService(),

      getMethod: "get",
      masterId: null,

      // Modal
      modalModel: { name: "", description: "", startDate: "", endDate: "" },
      isEdit: false,
      isCreate: false,

      // SaveFields
      saveFields: {
        Overview: [
          "firstName",
          "secondName",
          "lastName",
          "email",
          "login",
          "jobTitle",
          "comments",
          "dateFormat",
          "timeZoneId",
          "timeFormat",
          "agencyLinkId",
          "agencyLinkType",
          "agencyLinkAgencyId",
          "agencyLinkAgencyValue",
        ],
        Claims: ["claims"],
      },

      // use case
      listHeadersUseCases: [
        { name: "Type", value: "securityClaimServiceName" },
        { name: "Value", value: "securityClaimValue" },
      ],
      userRolesData: [],

      userRoleSelected: false,
      selectedRole: {},
      Validations,
    };
  },
  validations() {
    const agencyValidate = (v) => {
      const model = this.model;
      if (model.agencyLinkType === "MARS") return true;
      return !!v;
    };
    const withI18nMessage = createI18nMessage({ t: this.$t });
    const localRequired = withI18nMessage(required);
    const localMaxLength = withI18nMessage(maxLength(255));
    const localEmail = withI18nMessage(Validations.isEmail);
    const localAgencyValidate = withI18nMessage(agencyValidate);
    return {
      model: {
        lastName: {
          localRequired,
          localMaxLength,
        },
        firstName: {
          localRequired,
          localMaxLength,
        },
        secondName: {
          localRequired,
          localMaxLength,
        },
        email: {
          localRequired,
          localMaxLength,
          localEmail,
        },
        login: {
          localRequired,
          localMaxLength,
        },
        agencyLinkType: {
          localRequired,
        },
        agencyLinkAgencyId: {
          localAgencyValidate,
        },
      },
    };
  },
  mounted() {
    this.modelTab = this.tabs[0];
    this.modelTabPanel = this.profileTabs[0];
    this.getData();
  },
  methods: {
    agencyValidate(v) {
      const model = this.model;
      if (model.agencyLinkType === "MARS") return true;
      return !!v;
    },
    userTypeChanged(option) {
      this.model.agencyLinkAgencyId = null;
      this.model.agencyLinkAgencyValue = "";
    },
    updateModelField(data, field) {
      this.model[`agencyLink${field[0].toUpperCase() + field.slice(1)}Value`] =
        this.$refs[field].selectedItem.name;
    },
    handlerSelectRadio(tab) {
      if (tab.value === "profile") {
        this.modelTabPanel = this.profileTabs[0];
      } else if (tab.value === "permissions") {
        const activeTab = this.tabsPanel.find(i => i.isActive)
        this.modelTabPanel = activeTab || this.tabsPanel[0];
      }
    },
    userRoleGridLoaded() {
      this.userRolesData = this.$refs["userRoleGrid"].records;
      this.rolesLoading = false;
    },
    useCaseSelect(id) {
      if (id && this.$refs["userUseCase"]) {
        this.$refs["userUseCase"].userUseCaseService.get(id).then((r) => {
          if (r.data.useCaseId == this.selectedUseCaseId) {
            this.selectedUseCaseId = null;
            this.useCaseSelected = false;
          } else {
            this.selectedUseCaseId = r.data.useCaseId;
            this.useCaseSelected = true;
          }
        });
      } else {
        this.selectedUseCaseId = null;
        this.useCaseSelected = false;
      }
    },
    userRoleSelect(record) {
      if (
        record &&
        record.securityRoleId !== this.selectedRole.securityRoleId
      ) {
        this.selectedRole = record;
        this.userRoleSelected = true;
      } else {
        this.selectedRole = {};
        this.userRoleSelected = false;
      }
    },
    removeUserRole(model) {
      this.rolesLoading = true;
      this.userRoleService.delete([model]).then(() => {
        this.$refs["userRoleGrid"].getRecords(true);
        this.rolesLoading = false;
      });
    },
    formatDate(dateString, format) {
      let date = new Date(dateString);

      let yyyy = date.getFullYear();
      let mm = date.getMonth() + 1;
      let dd = date.getDate();

      let hours = date.getHours();
      let minutes = date.getMinutes();
      let time = { hours, minutes, ampm: "" };

      if (format.includes("hh")) time = this.formatAMPM(date);

      var formated = format
        .replace("dd", dd)
        .replace("MM", mm)
        .replace("yyyy", yyyy)
        .replace("HH", time.hours)
        .replace("hh", time.hours)
        .replace("mm", time.minutes);

      formated += `${time.ampm}`;

      return formated;
    },
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? " pm" : " am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return { hours, minutes, ampm };
    },
    async getData() {
      this.masterId = this.$route.params.id;
      if (this.masterId === undefined) {
        // redirect to 404
        return;
      }
      const result = await this.userService[this.getMethod](this.masterId);
      this.model = result.data;
      this.startModel = _.cloneDeep(this.model);
      this.userRoleService.setItem(this.model);
      this.restrictionService.setUserId(this.masterId);
      this.restrictionService.setUserCode(this.model.code);
      this.layoutName = this.model.secondName
        ? `${this.model.lastName} ${this.model.firstName} ${this.model.secondName}`
        : `${this.model.lastName} ${this.model.firstName}`;

      if (!this.model.dateFormat) {
        this.model.dateFormat = localStorage.getItem("dateFormat");
      } else {
        this.model.dateFormat = this.model.dateFormat
          .replaceAll("y", "Y")
          .replaceAll("m", "M")
          .replaceAll("d", "D");
      }

      if (this.model.id === this.userinfo.id) {
        this.$store.dispatch("userinfoStore/setUserinfo", this.model);
      }
    },
    applyRoles() {
      this.rolesLoading = true;
      this.$refs['userRoleGrid'].getRecords(true);
    },
    saveAll() {
      if (!this.v$.$dirty) {
        this.v$.$touch();
      }
      if (this.v$.$invalid) {
        return;
      }
      this.loading = true;
      this.userService.set().then(() => {
        this.getData();
        this.loading = false;
      });
    },
    savePart(fields) {
      if (!this.v$.$dirty) {
        this.v$.$touch();
      }
      this.loading = true;
      if (this.modelTabPanel.value === "restrictions") {
        this.restrictionService.save(this.masterId).then(() => {
          this.$refs["user-restriction"].getRecords();
          this.loading = false;
        });
      } else {
        this.userService.setPart(fields).then(async () => {
          await this.getData();
          if (this.model.code === this.userinfo.code) {
            this.userInfoService.get();
          }
          this.loading = false;
        });
      }
    },
    showModalForm(name) {
      this.$refs[name].show();
    },
    showMethadataModal() {
      this.$refs["user-restriction"].showModal();
    },
    submitFilter(nameRef = "grid") {
      if (!this.$refs[nameRef]) return;
      this.$refs[nameRef].getRecords(true);
    },
    createItem() {},
    deleteRecord(id) {},
    sendGridModal(model) {},
    backHandler() {
      this.$router.go(-1);
    },
    switchCurrentRoleHandler(el, event) {
      let me = this;
      me.loading = true;
      var grid = me.$refs["userRoleGrid"];
      if (grid.records != null) {
        me.userService
          .setUserCurrentRole(el.securityUserId, el.securityRoleId)
          .then(async () => {
            await grid.getRecords(true);
            me.loading = false;
          }).catch(e => {
            console.error(e);
            me.loading = false;
            me.$store.commit("errorStore/SET_ERROR403_MODAL", true);
          });;
      }
    },
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDate: "userinfoStore/getFormatDate",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    disabledSave() {
      return this.v$.model.$error || _.isEqual(this.model, this.startModel);
    },
    userPanelMeta() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    contentUserRoles() {
      if (this.selectedRole) {
        return [
          [
            {
              title: this.$t("name"),
              text: this.selectedRole.securityRoleSystemName,
            },
          ],
        ];
      }
      return [];
    },

    headerBottomUserRoles() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    contentBottomUserRoles() {
      if (this.selectedRole) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.selectedRole.createdBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.selectedRole.createdAt) + ' ' + getAMorPM(this.selectedRole.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.selectedRole.lastUpdated) + ' ' + getAMorPM(this.selectedRole.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
    },

    userRoleGridData() {
      return this.userRolesData;
    },
    tabs() {
      return [
        { label: this.$t("profile"), value: "profile" },
        { label: this.$t("permissions"), value: "permissions" },
      ];
    },
    profileTabs() {
      const user = {
        name: this.$t("userProfile"),
        value: "user",
      };
      return [user];
    },
    tabsPanel() {
      const roles = {
        name: this.$t("roles"),
        value: "roles",
        isActive: true,
      };
      const useCases = {
        name: this.$t("useCases"),
        value: "useCases",
      };
      const menuItems = {
        name: this.$t("menuItems"),
        value: "menuItems",
      };
      return [roles, useCases, menuItems];
    },
    isUseCaseSelected() {
      return this.modelTabPanel.value == "useCases" && this.useCaseSelected;
    },
    isUserRoleSelected() {
      return this.modelTabPanel.value == "roles" && this.userRoleSelected;
    },
    disabledModalRule() {
      return (
        this.modalModel.name.length == 0 ||
        this.modalModel.description.length == 0
      );
    },
    userPanelMetaContent() {
      return [
        [
          {
            title: this.$t("createdByTxt"),
            text: this.model.createdBy,
          },
        ],
        [
          {
            title: this.$t("createdAtTxt"),
            text: this.getFormatDateTime(this.model.createdAt) + ' ' + getAMorPM(this.model.createdAt, this.userinfo?.timeFormat),
          },
          {
            title: this.$t("lastUpdatedTxt"),
            text: this.getFormatDateTime(this.model.lastUpdated) + ' ' + getAMorPM(this.model.lastUpdated, this.userinfo?.timeFormat),
          },
        ],
      ];
    },
    customServices() {
      return [
        {
          type: "chips",
          model: "Code",
          label: this.$t("distributorCode"),
          selected: {},
        },
        {
          type: "chips",
          model: "LegalAddress",
          label: this.$t("distributorLegalAddress"),
          selected: {},
        },
        {
          type: "chips",
          model: "MailAddress",
          label: this.$t("distributorMailAddress"),
          selected: {},
        },
        {
          type: "chips",
          model: "PhoneNumber",
          label: this.$t("distributorPhoneNumber"),
          selected: {},
        },
        {
          type: "chips",
          model: "FaxNumber",
          label: this.$t("distributorFaxNumber"),
          selected: {},
        },
        {
          type: "chips",
          model: "emailAddress",
          label: this.$t("distributorEmailAddress"),
          selected: {},
        },
        {
          type: "checkboxes",
          service: new DistributorService(),
          getMethod: "getEDOs",
          model: "EDOProviderName",
          label: this.$t("distributorEDO"),
          optionValue: "value",
          optionLabel: "label",
          selected: {},
        },
        {
          type: "chips",
          model: "BankName",
          label: this.$t("distributorBankName"),
          selected: {},
        },
        {
          type: "chips",
          model: "BankPaymentAccount",
          label: this.$t("distributorBankPaymentAccount"),
          selected: {},
        },
        {
          type: "chips",
          model: "BankCorrespondentAccount",
          label: this.$t("distributorBankCorrespondentAccount"),
          selected: {},
        },
        {
          type: "chips",
          model: "BankBIC",
          label: this.$t("distributorBankBIC"),
          selected: {},
        },
        {
          type: "chips",
          model: "BankINN",
          label: this.$t("distributorBankINN"),
          selected: {},
        },
        {
          type: "chips",
          model: "BankKPP",
          label: this.$t("distributorBankKPP"),
          selected: {},
        },
        {
          type: "chips",
          model: "BankOGRN",
          label: this.$t("distributorBankOGRN"),
          selected: {},
        },
        {
          type: "chips",
          model: "createdBy",
          label: this.$t("createdByTxt"),
          selected: {},
        },
        {
          type: "chips",
          model: "updatedBy",
          label: this.$t("updatedByTxt"),
          selected: {},
        },
        {
          type: "dates-range",
          model: "createdAt",
          label: this.$t("createDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
        {
          type: "dates-range",
          model: "lastUpdated",
          label: this.$t("lastUpdatedTxt"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
      ];
    },
  },
};
</script>
<style lang="scss">
.user {
  .add-input-button {
    &__modal {
      .main-grid__without-header  {
        .p-datatable-tbody {
          height: auto !important;
        }
      }
    }
  }
  &__roles-grid {
    .prospace-input-switch__wrapper {
      justify-content: flex-start !important;
      height: 100% !important;
    }
    .prospace-text-block__bottom {
      color: var(--prospace-text-gray);
    }
  }
}
</style>
